<template>
  <div>

    <a  @click="fnShowModal()" class="p-2"><i class="far fa-trash-alt text-danger"></i></a>

    <b-modal ref="userModal" hide-footer title="User - Delete">
        <div class="d-block">
          <form v-on:submit.prevent="fnDeleteUser(userData.id)">

            <h4>Delete this user name <strong>{{ userData.firstName }}</strong>?</h4>
            <p>Are you sure? You won't be able to revert this!</p>
          <hr>
          <div class="text-right">
            <button type="button" class="btn btn-secondary btn-sm mr-2" @click="hideModal">Cancel</button>
            <button  type="submit" class="btn btn-danger btn-sm"
              
            >Delete</button>
          </div>
          </form>
        </div>
      </b-modal>
  </div>
</template>
<script>
    import { mapGetters, mapActions } from 'vuex';
    import * as messageService from '../../../services/message.service';
    import * as userService from '../../../services/user.service';
    export default {
        name:"ModelUserNew",
        props:['propsData'],
        components: {
            
        },
        data(){
            return{
                errors:{},
                userData:{
                    id:'',
                    firstName:'',
                    middleName:'',
                    lastName:'',
                    email:'',
                    profileImage:'',
                    role_id:'',
                },
            }
        },
        computed:{
            ...mapGetters(['gettUserAll']),
        },
        methods:{
            ...mapActions(['fetchUserAll']),
            fnShowModal(){
                this.fnGetValue(this.propsData)
                this.showModal();
            },
            hideModal(){
                this.$refs.userModal.hide();
            },
            showModal(){
                this.$refs.userModal.show();
            },

            fnGetValue(props){
                this.userSatus=false;
                this.userData.id = props.rowData.id;
                this.userData.firstName = props.rowData.firstName;
                this.userData.middleName = props.rowData.middleName;
                this.userData.lastName = props.rowData.lastName;
                this.userData.email = props.rowData.email;
                this.userData.role_id = props.rowData.role_id;
            },

            fnDeleteUser:async function(id){
                try{
                    const respose = await userService.deleteSingle(id);
                    this.fetchUserAll();
                    messageService.fnSweetAlertSuccessToast('User', 'Delete successfully');
                    this.hideModal();
                }catch(error){
                    messageService.fnSweetAlertErrorToast('User', error.response.data.message);
                }

            }
        }
    }
</script>